import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { FaCertificate, FaClock, FaHandshake, FaLeaf } from 'react-icons/fa';
import './WhyChooseUs.css';

const ICON_MAP = {
  certificate: <FaCertificate />, clock: <FaClock />,
  handshake: <FaHandshake />, leaf: <FaLeaf />
};

function WhyChooseUs() {
  const [items, setItems] = useState([]);
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  /* ---------- Fetch items ---------- */
  useEffect(() => {
    axios.get('https://api.hospifylink.com/api/whychoose').then(r => setItems(r.data)).catch(() => {});
  }, []);

  /* ---------- Detect when the section enters the viewport ---------- */
  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;

    // Fallback: if the browser doesn't support IntersectionObserver,
    // show everything immediately.
    if (typeof IntersectionObserver === 'undefined') {
      setInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
            observer.unobserve(entry.target);  // fire only once
          }
        });
      },
      {
        threshold: 0.15,                    // trigger when ~15% of section is visible
        rootMargin: '0px 0px -60px 0px'     // fire slightly before it fully enters
      }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`whychoose-root ${inView ? 'whychoose-in-view' : ''}`}
      ref={sectionRef}
    >
      <h2 className="lca-section-title whychoose-title">Why Choose Us</h2>
      <p className="lca-section-sub whychoose-subtitle">
        We make hiring hospitality professionals simple
      </p>

      <div className="whychoose-grid">
        {items.map((it, i) => (
          <div
            key={it.id || i}
            className="whychoose-card"
            style={{ animationDelay: `${i * 0.12}s` }}
          >
            <div className="whychoose-icon">{ICON_MAP[it.icon] || <FaCertificate />}</div>
            <h3>{it.title}</h3>
            <p>{it.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default WhyChooseUs;
